<form [formGroup]="userAttributesSwiftForm" class="swift-attribite">
    <div class="text-1">Enter the allocation </div>
    <div class="text-2"> Note: Allocation must add upto 100% in one or multiple investment options </div>
    <div class="flex-container" formArrayName="fundAllocationPercent">
        <div *ngFor="let product of subProducts; let i=index" class="products-wrap">
            <div class="flex-box" [formGroupName]="i">
                <div>
                    <div class="input-label">{{product.name}}</div>
                    <input class="input-field" (keypress)="isNumberKey($event)" (keyup)="onInputChanges()"
                    type="number" min="1" placeholder="Allocation in %" formControlName="attributeValue" max="100"
                    onKeyPress="if(this.value.length==3) return false;" />
                    <span *ngIf="userAttributesSwiftForm?.controls?.fundAllocationPercent?.controls[i]?.controls?.attributeValue?.value" class="percent-symbol">%</span>
                </div>
                <ng-container *ngIf="product.maturity_days; else no_maturity_days">
                    <div class="note">Maturity 
                        <app-tooltip class="tooltip-section" placement="bottom">
                            <i class="infoIcon material-icons" trigger>info_outline</i>
                            <div class="tooltip-max" content>
                                <strong class="text-black">Maturity</strong> 
                                months is the period during which the 
                                <strong class="text-black">finzyFLEX</strong> 
                                investments cannot be withdrawn to bank account.
                            </div>
                        </app-tooltip>
                        <strong class="note-strong">&nbsp;&nbsp;{{product.mhp}}m</strong>
                    </div>
                </ng-container>
                <ng-template #no_maturity_days>
                    <div class="note">MHP 
                        <app-tooltip class="tooltip-section" placement="bottom">
                            <i class="infoIcon material-icons" trigger>info_outline</i>
                            <div class="tooltip-max" content>
                                Minimum Holding Period (<strong class="text-black">MHP</strong>) 
                                is the period of months during which the 
                                <strong class="text-black">finzyFLEX</strong> 
                                investments cannot be withdrawn to bank account.
                            </div>
                        </app-tooltip>
                        <strong class="note-strong">&nbsp;&nbsp;{{product.mhp}}m</strong>
                    </div>
                </ng-template>                
                <ng-container *ngIf="product.maturity_days; else default_interest_text">
                    <div class="note line-height-normal">Interest:<strong class="note-strong">&nbsp;&nbsp;upto {{product.roi}}% p.a. (20% for 18 months)</strong></div>
                </ng-container>
                <ng-template #default_interest_text>
                    <div class="note line-height-normal">Interest:<strong class="note-strong">&nbsp;&nbsp;upto {{product.roi}}% p.a.</strong></div>
                </ng-template>
            </div>
        </div>
    </div>
    <div>
        <div class="" *ngIf="userAttributesSwiftForm.get('fundAllocationPercent')?.invalid">
            <div
                *ngIf="userAttributesSwiftForm.get('fundAllocationPercent').errors?.error == 'allocateFundFormValidatorError'">
                <span class="error-text mt-3">Allocation must add upto 100% in one or multiple investment options</span>
            </div>
            <div
                *ngIf="userAttributesSwiftForm.get('fundAllocationPercent').errors?.error == 'negativeValueValidatorError'">
                <span class="error-text mt-3">Allocation must not be negative</span>
            </div>
            <div *ngIf="userAttributesSwiftForm.get('fundAllocationPercent').errors?.error == 'negativeValueValidatorError'">
                <span class="error-text mt-3">Allocation must not be negative</span>
            </div>
            <div class="mt-2">
                <span>
                    <strong>Note: </strong>Your preferences will be reverted back to your previous preference setup in case of product unavailability
                </span>
            </div>
        </div>

    </div>
</form>